import { useEffect, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useParams } from "react-router-dom";
import { useToast } from "../../contexts/ToastContext";
import useApi from "../../hooks/useApi";

const ModalEditAloj = ({ info, fetchData }) => {

    const { matricula } = useParams();
    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();

    const api = useApi();

    const [loading, setLoading] = useState(true);

    const [republicas, setRepublicas] = useState([]);
    const [quartos, setQuartos] = useState([]);

    const [formValues, setFormValues] = useState({
        alojamento: info.rep_id || '',
        quarto: info.quarto_id || '',
        check_in: info.check_in || '',
        check_out: info.check_out || ''
    })

    useEffect(() => {

        const fetchData = async () => {

            setLoading(true);
            try {
                const promises = [
                    api.post('/Painel/API/Colaborador/GetRepublicas/', { republica: info.rep_id, centro_custo: info.centro_custo })
                ]
                if (info.quarto_id) {
                    promises.push(api.post('/Painel/API/Colaborador/GetQuartos/', { republica: info.rep_id }))
                }

                const [repsRes, quartosRes] = await Promise.all(promises);

                setRepublicas(repsRes.data.map(obj => ({
                    label: obj.nome,
                    value: obj.identifier
                })))

                if (info.quarto_id) {
                    setQuartos(quartosRes.data.map(obj => ({
                        label: obj.quarto_name,
                        value: obj.identifier
                    })))
                }

            } catch (e) {
                console.error(e)
            } finally {
                setLoading(false);
            }

        }

        fetchData();

    }, [info])

    useEffect(() => {

        const fetchQuartos = async () => {

            setLoading(true);

            try {
                const { data } = await api.post('/Painel/API/Colaborador/GetQuartos/', { republica: formValues.alojamento })
                setQuartos(data.map(obj => ({
                    label: obj.quarto_name,
                    value: obj.identifier
                })))
            } catch (e) {
                console.error(e)
            } finally {
                setLoading(false);
            }

        }

        if (formValues.alojamento !== "") {
            fetchQuartos();
        } else {
            setQuartos([]);
        }

    }, [formValues.alojamento])

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormValues({
            ...formValues,
            [name]: value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {

            const payload = { ...formValues }
            payload.matricula = matricula

            await api.post('/Painel/API/Colaborador/SaveAloj/', payload);

            await fetchData();
            notifySuccess("Dados atualizados com sucesso!");
            closeModal();

        } catch (e) {

            console.error(e);
            notifyError("Erro ao atualizar dados do colaborador.");

        } finally {

            setLoading(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="ALOJAMENTO"
                            type="select"
                            options={republicas}
                            obj={true}
                            valor={formValues.alojamento}
                            changeFunc={(e) => {
                                const value = e.target.value
                                setFormValues(prev => ({
                                    ...prev,
                                    alojamento: value,
                                    quarto: ''
                                }))
                            }}
                        />
                        <FormComp
                            title="QUARTO"
                            type="select"
                            options={quartos}
                            obj={true}
                            valor={formValues.quarto}
                            name="quarto"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="CHECK-IN"
                            type="date"
                            valor={formValues.check_in}
                            name="check_in"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="CHECK-OUT"
                            type="date"
                            valor={formValues.check_out}
                            name="check_out"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true} >
                    <Modal size="sm" >
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    )
}

export default ModalEditAloj;